<svelte:options customElement="hb-messages-box" />

<script lang="ts">
  import pkg from "../../../package.json";

  import parseStyle from "style-to-object";
  import {
    addComponent,
    getChildStyleToPass,
    LanguageTranslator,
  } from "wc-js-utils";
  import type { Component as messageListComponent } from "../messages-list/types/webcomponent.type";
  import type { Events as messageSendEvents } from "../messages-send/types/webcomponent.type";
  import type { Component } from "./types/webcomponent.type";

  import { styleSetup as messageListStyleSetup } from "../messages-list/extra/docs";
  import { styleSetup as messageSendStyleSetup } from "../messages-send/extra/docs";

  function dispatch(name: string, detail: any) {
    $host().dispatchEvent(new CustomEvent(name, { detail }));
  }

  let {
    id = "",
    // style = "",
    messages,
    authors,
    options,
    message = { text: "" },
  }: Component = $props();

  let messagesListStyleSetupToSet: string = $state("");
  let messagesSendStyleSetupToSet: string = $state("");

  let parsedStyle: { [x: string]: string } = $state({});
  //  let componentStyleToSet: string = "";
  let textMessage: string = $derived.by(() => {
    if (typeof message === "string") {
      try {
        message = JSON.parse(message);
      } catch (err) {
        console.error("error parsing message", err);
      }
    }

    return message?.text ? message.text : "";
  });

  function sendMessageEvent(sendDetail: messageSendEvents["sendMessage"]) {
    if (!(sendDetail as any)?.file && !sendDetail?.text)
      return console.warn("no message to received", sendDetail);
    dispatch("sendMessage", sendDetail);
    textMessage = sendDetail.text as string;
    textMessage = "";

    // const newMessage: messageListComponent["messages"][0] = {
    // 	id: Date.now().toString(),
    // 	text: sendDetail.text,
    // 	timestamp: new Date(Date.now()),
    // 	type: "text",
    // 	authorId: "1",
    // };
    // messages = [...messages, newMessage];
  }

  addComponent({
    repoName: "@htmlbricks/hb-messages-list",
    version: pkg.version,
  });
  addComponent({
    repoName: "@htmlbricks/hb-messages-send",
    version: pkg.version,
  });
</script>

<div id="compocontainer">
  <div id="list">
    <hb-messages-list
      id="message-list"
      {messages}
      {authors}
      {options}
      style={messagesListStyleSetupToSet}
      class="msglist"
      part="msglist"
    ></hb-messages-list>
  </div>
  <div id="prompt">
    <hb-messages-send
      text={textMessage}
      part="msgsend"
      style={messagesSendStyleSetupToSet}
      onsendMessage={(e: { detail: messageSendEvents["sendMessage"] }) =>
        sendMessageEvent(e.detail)}
    ></hb-messages-send>
  </div>
</div>

<style lang="scss">
  @forward "./styles/webcomponent.scss";
  // @forward "./styles/bootstrap.scss";
</style>
